export default __webpack_public_path__ + "static/Final-d0d64dccaf69876ea4e5a0cabb5e7680.jpg";